import { Box, SxProps, Theme, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { DateFormat, i18nFormat } from 'utils/date.utils';

import { useLocale } from 'hooks/useLocale';

interface Props {
  dateTime?: string;
  sx?: SxProps<Theme>;
}

const UpdatedAtSeparator = ({ dateTime, sx }: Props) => {
  const { locale } = useLocale();

  if (!dateTime) return null;

  return (
    <Box
      sx={[
        {
          color: 'grey.500',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Typography
        component="span"
        variant="overline"
        sx={{
          color: 'grey.500',
        }}
      >
        <FormattedMessage id="date.last.updated" />
        &nbsp;
        {i18nFormat(new Date(dateTime), DateFormat.DateTime, locale)}
      </Typography>
    </Box>
  );
};

export default UpdatedAtSeparator;
